/**
 * hình thức hóa đơn
 */
export default {
  Transfer: 0, // Chuyển khoản
  CashKB: 1, // Tiền mặt tại kho bạc
  CashNH: 2, // Tiền mặt tại ngân hàng
  Cash: 3, //tiền mặt
};
